import React from 'react';
import { Facebook, Twitter, Linkedin, Link as LinkIcon, Mail } from 'lucide-react';
import { Button } from './ui/button';
import { useToast } from '../hooks/use-toast';

const SocialShare = ({ url, title, description }) => {
  const { toast } = useToast();
  const shareUrl = url || window.location.href;
  const shareTitle = title || document.title;
  const shareDescription = description || '';

  const copyToClipboard = () => {
    navigator.clipboard.writeText(shareUrl);
    toast({
      title: "Link Copied!",
      description: "Share link copied to clipboard.",
    });
  };

  const shareLinks = {
    facebook: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}`,
    twitter: `https://twitter.com/intent/tweet?url=${encodeURIComponent(shareUrl)}&text=${encodeURIComponent(shareTitle)}`,
    linkedin: `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(shareUrl)}`,
    email: `mailto:?subject=${encodeURIComponent(shareTitle)}&body=${encodeURIComponent(shareDescription + '\n\n' + shareUrl)}`
  };

  const openShareWindow = (url) => {
    window.open(url, '_blank', 'width=600,height=400');
  };

  return (
    <div className="flex items-center space-x-2">
      <span className="text-sm text-gray-400 mr-2">Share:</span>
      
      <Button
        variant="outline"
        size="sm"
        className="border-gray-700 hover:bg-gray-800 hover:border-orange-500"
        onClick={() => openShareWindow(shareLinks.twitter)}
        title="Share on Twitter"
      >
        <Twitter className="h-4 w-4" />
      </Button>

      <Button
        variant="outline"
        size="sm"
        className="border-gray-700 hover:bg-gray-800 hover:border-orange-500"
        onClick={() => openShareWindow(shareLinks.linkedin)}
        title="Share on LinkedIn"
      >
        <Linkedin className="h-4 w-4" />
      </Button>

      <Button
        variant="outline"
        size="sm"
        className="border-gray-700 hover:bg-gray-800 hover:border-orange-500"
        onClick={() => openShareWindow(shareLinks.facebook)}
        title="Share on Facebook"
      >
        <Facebook className="h-4 w-4" />
      </Button>

      <Button
        variant="outline"
        size="sm"
        className="border-gray-700 hover:bg-gray-800 hover:border-orange-500"
        onClick={() => window.location.href = shareLinks.email}
        title="Share via Email"
      >
        <Mail className="h-4 w-4" />
      </Button>

      <Button
        variant="outline"
        size="sm"
        className="border-gray-700 hover:bg-gray-800 hover:border-orange-500"
        onClick={copyToClipboard}
        title="Copy Link"
      >
        <LinkIcon className="h-4 w-4" />
      </Button>
    </div>
  );
};

export default SocialShare;
